/**
 * @name          jQuery Layer Plugin
 * @version       1.0
 * @lastmodified  2015-10-23
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JR, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'layer',
		defaults = {
			navigationTopPadding: 20,
			navigationTopAnimationDuration: 400,
			scrollDuration: 400,
			scrollDurationOnLoad: 800,
			debounceScrollTimeout: 150,
			showNavigationMinWidth: 768,
			anchorActiveWindowHeightMultiplier: 0.5,
			historyBackFallback: '/'
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);
		this.init();
	}

	// methods
	var methods = {
		init: function() {

			var self = this;
			this.urlParameters = $.deparam( window.location.search.replace(/^\?/,'') );
			this.$header = this.$element.children('.layer__header');
			this.$content = this.$element.children('.layer__content');
			this.$stickyHeader = this.$header.clone().addClass('layer--sticky');
			this.$navigationAnchors = this.$content.find('[data-layer-anchor]');
			this.isSticky = false;
			this.activeNavigationIndex = -1;
			this.hasNavigation = false;

			// clone and insert sticky header
			this.$stickyHeader.insertAfter(this.$header);
			this.$stickyHeaderHeight = this.$stickyHeader.innerHeight();

			// toggle sticky header on load
			this.toggleStickyHeader( $(window).scrollTop() );

			// always listen to scroll event
			$(window).on('scroll.layer', function() {
				var scrollTop = $(window).scrollTop();

				// toggle sticky header view
				self.toggleStickyHeader(scrollTop);

				// debounce navigation state changes
				if( self.hasNavigation ) {

					clearTimeout(self.navigationStateTimeout);
					self.navigationStateTimeout = setTimeout(function() {
						self.setNavigationState(scrollTop);
					}, self.options.debounceScrollTimeout);

				}
			});

			// init navigation
			enquire.register('screen and (min-width: '+this.options.showNavigationMinWidth+'px)', {

				deferSetup: true,
				setup: function() {

					self.initNavigation();

				},

				match: function() {

					self.hasNavigation = self.$navigationAnchors.length > 0;
					if(self.hasNavigation) {

						// initially set navigation position
						self.setNavigationState( $(window).scrollTop() );

						// listen to scroll events to stickify header
						$(window).on('debouncedwidth.layer', function() {
							self.setNavigationTopPosition( 0 );
						});

					}

				},

				unmatch: function() {

					self.hasNavigation = false;
					$(window).off('debouncedwidth.layer');

				}
			});

			// check for read more functionality in header description
			var $headerDescription = this.$header.find('.layer__description.readmore');
			if($headerDescription.length > 0) {
				$.attachFailsafeEvent($headerDescription, 'plugin_readmore.ready', function() {
					if(self.hasNavigation) {
						self.setNavigationTopPosition( 0 );
						self.setNavigationState( $(window).scrollTop() );
					}
				});

				self.$header.on('readmore_more readmore_less', '.readmore', function() {
					self.setNavigationTopPosition( 0 );
				});
			}

			// check for direct anchor in url
			this.scrollToAnchor();

			// listen to close click
			this.$element.find('.layer__close').on('click', function(e) {
				e.preventDefault();
				self.closeLayer();
			});

		},

		initNavigation: function() {

			var self = this;

			// search for navigation anchors
			this.hasNavigation = this.$navigationAnchors.length > 0;

			if( this.hasNavigation ) {

				// generate navigation element
				this.$navigation = $('<ul class="layer__navigation"/>');
				$.each(this.$navigationAnchors, function() {

					self.$navigation.append(
						$('<a/>')
							.prop('href', '#')
							.prop('title', $(this).data('anchor-title') || '')
							.data('anchor', $(this).data('layer-anchor'))
							.wrap('<li/>')
							.parent()
					);
				});

				// append navigation to dom
				this.$navigation.insertBefore( this.$content );

				// save LIs for later usage
				this.$navigationDots = this.$navigation.children('li');

				// show navigation
				this.$element.addClass('layer--showNavigation');

				// set top position of navigation dots relative to default header
				this.setNavigationTopPosition( 0 );

				// listen to clicks on navigation dots
				this.$navigation.find('a').on('click', function(e) {
					e.preventDefault();

					var $anchor = self.$content.find('[data-layer-anchor="'+$(this).data('anchor')+'"]');
					if( $anchor.length > 0 ) {
						$('html, body').animate({
							scrollTop: ($anchor.offset().top - self.$stickyHeaderHeight + 1)
						}, self.options.scrollDuration);

						self.activateNavigationDot( self.$navigationDots.index( $(this).parent('li') ) );
						self.ignoreNextNavigationState = true;
					}
				});


			} else {
				this.$element.removeClass('layer--showNavigation');
			}

		},

		toggleStickyHeader: function(scrollTop) {

			var stickyTopPosition = this.$header.innerHeight() - this.$stickyHeaderHeight;
			if (scrollTop >= stickyTopPosition && !this.isSticky) {

				this.isSticky = true;
				this.$element.addClass('layer--showSticky');
				this.$header.fadeTo(0, 0);
				this.setNavigationTopPosition( this.options.navigationTopAnimationDuration );

			} else if (scrollTop < stickyTopPosition && this.isSticky) {

				this.isSticky = false;
				this.$element.removeClass('layer--showSticky');
				this.$header.fadeTo(400, 1);
				this.setNavigationTopPosition( this.options.navigationTopAnimationDuration );

			}

		},

		setNavigationTopPosition: function(duration) {

			if( this.hasNavigation ) {

				var paddingTop = this.isSticky ? this.$stickyHeaderHeight : this.$header.innerHeight();
				paddingTop += this.options.navigationTopPadding;

				this.$navigation.animate({
					'padding-top': paddingTop
				}, duration);
			}

		},

		setNavigationState: function(scrollTop) {

			// ignore navigation state change caused by click in navigation
			if( this.ignoreNextNavigationState ) {
				this.ignoreNextNavigationState = false;
				return;
			}

			var activeIndex = 0;

			// ignore navigation states until first anchor hits top border
			if( scrollTop > this.$navigationAnchors.first().offset().top - this.$stickyHeaderHeight ) {
				var windowHeight = $(window).height();

				// check visibility descending
				var i = this.$navigationAnchors.length;
				while( i-- ) {

					var $this = $(this.$navigationAnchors[i]);
					var offsetTop = $this.offset().top;
					var height = $this.height();

					var anchorTopAboveHeader   = ( offsetTop <= (scrollTop + windowHeight) );
					var anchorBottomInViewport = ( (offsetTop + height) <= (scrollTop + windowHeight) );
					var anchorTopAboveLimit    = ( offsetTop <= (scrollTop + (windowHeight * this.options.anchorActiveWindowHeightMultiplier)) );

					if( anchorTopAboveHeader && (anchorBottomInViewport || anchorTopAboveLimit) ) {
						activeIndex = $this.index();
						break;
					}

				}

			}

			this.activateNavigationDot(activeIndex);

		},

		activateNavigationDot: function( activeIndex ) {

			// change active navigation dot
			if( this.activeNavigationIndex !== activeIndex ) {

				this.activeNavigationIndex = activeIndex;
				this.$navigationDots.removeClass('layer__navigation--active');
				this.$navigationDots.eq(activeIndex).addClass('layer__navigation--active');

			}

		},

		scrollToAnchor: function() {

			if(this.urlParameters.anchor) {

				var $anchor = this.$content.find('[data-layer-anchor="'+this.urlParameters.anchor+'"]');

				// don't scroll for first element
				if( $anchor.length > 0 && this.$navigationAnchors.index( $anchor ) > 0 ) {
					$('html, body').animate({
						scrollTop: ($anchor.offset().top - this.$stickyHeaderHeight + 1)
					}, this.options.scrollDurationOnLoad);
				}

			}

		},

		closeLayer: function() {

			window.location.href = window.location.protocol + '//' + window.location.host + decodeURIComponent(this.urlParameters.back) || this.options.historyBackFallback;

		}
	};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function(options) {
		this.each(function() {
			if(!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				/**
				 * DEV-note: Use trigger failsafe events if other plugins depend on this plugins ready state
				 */
				// trigger ready event on element - optional
				//$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally - optional
		//if(this.length > 0) {
		//    $.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		//}

		return this;
	};

})(jQuery, window, document);
